import { token } from "@may-i/mash-design-system";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

/**
 * 권한 없는 매장 링크로 들어왔을 때 보여주는 화면.
 *
 * 이전에는 매장 하위 API 에 권한 검사가 없어서 남의 고객사 매장이 그냥 열렸고,
 * 상단 매장/버전 셀렉터만 빈 채로 남아 무슨 상황인지 알 수 없었다.
 */
export function BranchForbiddenPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("shared");

  return (
    <PageContainer>
      <Content>
        <TextGroup>
          <Title>{t("branchForbidden.title")}</Title>
          <Description>{t("branchForbidden.description")}</Description>
        </TextGroup>
        <HomeButton onClick={() => navigate("/", { replace: true })}>
          {t("branchForbidden.homeButton")}
        </HomeButton>
      </Content>
    </PageContainer>
  );
}

const PageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${token("colors.gray.white")};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`;

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const Title = styled.h1`
  margin: 0;
  text-align: center;
  font-family: Pretendard;
  font-size: 28px;
  font-weight: 700;
  line-height: 130%;
  color: ${token("colors.text.primary")};
`;

const Description = styled.p`
  margin: 0;
  text-align: center;
  white-space: pre-line;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 400;
  line-height: 130%;
  color: ${token("colors.text.secondary")};
`;

const HomeButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 12px 22px;
  border: none;
  border-radius: 8px;
  background: ${token("colors.brand.MB500")};
  color: ${token("colors.gray.white")};
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
`;
